import {
  type EnvironmentProviders,
  inject,
  makeEnvironmentProviders,
  provideAppInitializer,
} from '@angular/core';
import { RouteReuseStrategy } from '@angular/router';

import { NavReuseStrategy } from './nav-reuse.strategy';
import { NavStore } from './nav.store';

export function provideNav(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: RouteReuseStrategy,
      useClass: NavReuseStrategy,
    },
    provideAppInitializer(() => {
      inject(NavStore);
    }),
  ]);
}
